import { render, staticRenderFns } from "./new-prefabricated-wall-system-development.vue?vue&type=template&id=5b1ff7cd&"
import script from "./new-prefabricated-wall-system-development.vue?vue&type=script&lang=js&"
export * from "./new-prefabricated-wall-system-development.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports